import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.finq.in";

interface SeoProps {
  title: string;
  description?: string;
  path: string;
  noindex?: boolean;
}

export const Seo = ({ title, description, path, noindex = false }: SeoProps) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
    </Helmet>
  );
};
